import {
  Space,
  Button,
  Card,
  QRCode,
  Col,
  Row,
  Tag,
  Typography,
  Form,
  InputNumber,
} from "antd";
import Settings from "../../dependencies/custom/settings";
import useModal from "../../hooks/modal";
import useExportPDF from "../../hooks/pdf";
import CustomFunctions from "../../dependencies/custom/custom-functions";
// import useAdd from '../../hooks/add';
import ValuesStore from "../../store/values-store";
import { useEffect } from "react";

const { Text, Title } = Typography;

export default function useMyJSX() {
  const storeName = "invoiceStatus";
  const modal = useModal();
  const pdf = useExportPDF();
  const [form] = Form.useForm();
  // const add = useAdd(storeName, 'table_name');
  const valuesStore = ValuesStore();

  useEffect(() => {
    // setTimeout(()=>{
    //     valuesStore.setValue(storeName,[
    //         {
    //             table_name:'INVOICE_STATUS',
    //             colunm
    //         }
    //     ]);
    // },500);
  }, []);

  function fuelJSX(itemToView) {
    return (
      <Card bordered={false} style={{ backgroundColor: "#fafafa" }}>
        <Title level={5} style={{ color: "#1890ff" }}>
          Fuel Request #{itemToView?.requestNumber}
        </Title>

        {/* Status badge with dynamic color */}
        {itemToView?.status && (
          <Tag
            color={itemToView.status.includes("Generated") ? "green" : "orange"}
            style={{ marginBottom: "1rem" }}
          >
            {itemToView.status}
          </Tag>
        )}

        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Text strong>Driver' Name: </Text>
            <Text type={itemToView?.driverName ? "success" : "secondary"}>
              {itemToView?.driverName || "Not Assigned"}
            </Text>
          </Col>
          <Col span={12}>
            <Text strong>Litres: </Text>
            <Text style={{ color: "#722ed1" }}>
              {itemToView?.requestLitres}
            </Text>
          </Col>
          <Col span={12}>
            <Text strong>Exceptional: </Text>
            <Text type={itemToView?.exceptional ? "danger" : "secondary"}>
              {itemToView?.exceptional ? "Yes" : "No"}
            </Text>
          </Col>
          <Col span={12}>
            <Text strong>Date: </Text>
            <Text style={{ color: "#13c2c2" }}>
              {itemToView?.date ? new Date(itemToView.date).toDateString() : ""}
            </Text>
          </Col>
          <Col span={12}>
            <Text strong>Coupon Code: </Text>
            <Text type={itemToView?.couponCode ? "success" : "warning"}>
              {itemToView?.couponCode || "Pending"}
            </Text>
          </Col>
          <Col span={24}>
            <Text strong>Purpose: </Text>
            <Text>{itemToView?.purpose}</Text>
          </Col>
          <Col span={24}>
            <Text strong>Remarks: </Text>
            <Text>{itemToView?.remarks || itemToView?.comments}</Text>
          </Col>
          <Col span={24}>
            {itemToView?.couponCode && (
              <Space direction="vertical">
                <QRCode
                  value={`${Settings?.urls?.transport?.fuel_coupons_redeem}?couponcode=${itemToView?.couponCode}&litres=${itemToView?.requestLitres}`}
                />
                <div>
                  <Button
                    onClick={(e) =>
                      CustomFunctions.printCoupon(itemToView, pdf)
                    }
                    className="mt-2"
                    type="primary"
                    icon={<i className="fas fa-print" />}
                  >
                    Print Coupon
                  </Button>
                </div>
              </Space>
            )}
          </Col>
        </Row>
      </Card>
    );
  }

  // function maintenanceExtraJSX(extraItemToView) {
  //     console.log(extraItemToView);
  //     return 23485;
  // }

  function maintenanceJSX(
    itemToView /*, setExtraItemToView, extraItemDrawer, navigate*/,
  ) {
    return (
      <Card style={{ backgroundColor: "#fafafa" }}>
        <Title level={5} style={{ color: "#1890ff" }}>
          Maintenance Request #{itemToView?.maintenanceRequestNumber}
        </Title>

        {/* Status badge with dynamic color */}
        {itemToView?.status && (
          <Tag
            color={itemToView.status.includes("Generated") ? "green" : "orange"}
            style={{ marginBottom: "1rem" }}
          >
            {itemToView.status}
          </Tag>
        )}

        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Text strong>Driver's Name: </Text>
            <Text type={itemToView?.driverName ? "success" : "secondary"}>
              {itemToView?.driverName || "Not Assigned"}
            </Text>
          </Col>
          <Col span={24}>
            <Text strong>Registration Number Plate: </Text>
            <Text style={{ color: "#722ed1" }}>
              {itemToView?.busPlateNumber}
            </Text>
          </Col>
          <Col span={24}>
            <Text strong>Maintenance Type: </Text>
            <Text>{itemToView?.maintenanceType}</Text>
          </Col>
          <Col span={24}>
            <Text strong>Title: </Text>
            <Text>{itemToView?.issue}</Text>
          </Col>
          <Col span={24}>
            <Text strong>Description: </Text>
            <Text>{itemToView?.description}</Text>
          </Col>
          <Col span={24}>
            <Text strong>Remarks: </Text>
            <Text>{itemToView?.remarks}</Text>
          </Col>
          <Col span={12}>
            <Text strong>Date: </Text>
            <Text style={{ color: "#13c2c2" }}>
              {itemToView?.createdAt
                ? new Date(itemToView.createdAt).toDateString()
                : ""}
            </Text>
          </Col>

          <Col span={24}>
            {itemToView?.maintenanceRequestNumber && (
              <Space>
                <Button
                  onClick={(e) =>
                    CustomFunctions.printRepairJobCard(itemToView, pdf)
                  }
                  className="mt-2"
                  type="primary"
                  icon={<i className="fas fa-print" />}
                >
                  Print Job Card
                </Button>
                {/* <Button onClick={e => CustomFunctions.viewInvoice(itemToView, setExtraItemToView, extraItemDrawer, maintenanceExtraJSX, navigate)} className='mt-2' type='primary' icon={<i className='fas fa-eye' />}>View Invoice</Button> */}
              </Space>
            )}
          </Col>
        </Row>
        {/* {extraItemDrawer?.drawerJSX?.(1000)} */}
      </Card>
    );
  }

  function invoiceUploadJSX(uploadJSX, onUpload, params, loading, setLoading) {
    return (
      <Form form={form} layout="vertical" key="invoice" name="invoice">
        <Form.Item name="totalCost" label="Total Invoice Cost " required>
          <InputNumber />
        </Form.Item>
        {uploadJSX?.()}

        <Form.Item>
          <Button
            loading={loading}
            onClick={(e) => onUpload?.(params, setLoading)}
            icon={<i className="fas fa-upload" />}
            type="primary"
          >
            Upload
          </Button>
        </Form.Item>
      </Form>
    );
  }

  return {
    fuelJSX,
    maintenanceJSX,
    form,
    invoiceUploadJSX /*maintenanceExtraJSX*/,
  };
}
